// Client-side heuristics that flag risky messages FROM the other person in a chat:
// requests involving money, or attempts to move the conversation to a personal
// contact channel. This is a soft, informational caution (never blocks the message)
// — it complements the server-side explicit-content moderation.

export type ChatRisk = 'money' | 'contact' | null

// Strong money/scam indicators (kept specific to avoid over-flagging normal chat).
const MONEY_RE = /\b(money|cash|paise|paisa|rupees?|upi|g[\s-]?pay|google\s?pay|phone\s?pe|paytm|otp|ifsc|gift\s?card|western\s?union|bank\s?account|account\s?number|send\s?money|need\s?money|transfer\s?money|emergency\s?fund)\b/i
const RUPEE_RE = /(₹|\brs\.?\b)\s?\d/i

// Moving off-platform / sharing contact info.
const APP_RE = /\b(whats\s?app|telegram|signal)\b/i
const EMAIL_RE = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/i

export function detectChatRisk(text: string | null | undefined): ChatRisk {
  if (!text) return null
  if (MONEY_RE.test(text) || RUPEE_RE.test(text)) return 'money'
  // Phone number: 10+ consecutive digits after removing common separators.
  const digits = text.replace(/[\s\-().]/g, '')
  if (/\d{10,}/.test(digits) || EMAIL_RE.test(text) || APP_RE.test(text)) return 'contact'
  return null
}

export function chatRiskMessage(risk: ChatRisk): string | null {
  if (risk === 'money') return 'Mentions money — never send money or share bank/OTP details.'
  if (risk === 'contact') return 'Sharing contact info early can be risky — keep chatting here until you trust them.'
  return null
}
